import React, {Component} from 'react';
import {Card, Layout} from 'antd';
import SAInputLabel from '../../../components/common/input/SAInputLabel';
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";

class PersonalInformationFragment extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderInputLabel = (name, value, label, onChange, isMandatory, disabled, maxLenght) => (
    <li>
      <SAInputLabel
        name={name}
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        maxLength={maxLenght}
        error={isMandatory && !value ? { message: 'error.not.null' } : null}
      />
    </li>
  );

  renderAddressCard = (
    formatMessage,
    number,
    street,
    zipCode,
    city,
    country,
    onNumberChange,
    onStreetChange,
    onZipCodeChange,
    onCityChange,
    onCountryChange
  ) => (
    <Card
      title={<h2>{formatMessage({id: 'customer.journey.step.personalInformation.addressTitle'}).toUpperCase()}</h2>}
      bordered={false}
      style={{ width: '100%', marginBottom: 25 }}
    >
      <div className="wrap">
        <div className="content">
          <ul className="list">
            {this.renderInputLabel(
              'Vehicle',
              street,
              'customer.journey.personalInformation.address.street',
              onStreetChange,
              true
            )}
            {this.renderInputLabel(
              'number',
              number,
              'customer.journey.personalInformation.address.number',
              onNumberChange,
              true
            )}
            {this.renderInputLabel(
              'Zipcode',
              zipCode,
              'customer.journey.personalInformation.address.zipCode',
              onZipCodeChange,
              true
            )}
            {this.renderInputLabel(
              'City',
              city,
              'customer.journey.personalInformation.address.city',
              onCityChange,
              true
            )}
            {this.renderInputLabel(
              'Country',
              country,
              'customer.journey.personalInformation.address.country',
              onCountryChange,
              true
            )}
          </ul>
        </div>
      </div>
    </Card>
  );

  render() {
    const {intl: {formatMessage}, onNumberChange, onStreetChange, onZipCodeChange, onCityChange, onCountryChange, number, street, zipCode, city, country} = this.props;

    return (
      <Layout style={{ backgroundColor: 'transparent' }}>
        {this.renderAddressCard(
          formatMessage,
          number,
          street,
          zipCode,
          city,
          country,
          onNumberChange,
          onStreetChange,
          onZipCodeChange,
          onCityChange,
          onCountryChange
        )}
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch => ({
});

const mapStateToProps = state => ({
  createAppointmentRequest: state.createAppointmentRequest
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PersonalInformationFragment)
);
